import { render, staticRenderFns } from "./client-logs.vue?vue&type=template&id=79579f38&"
import script from "./client-logs.vue?vue&type=script&lang=js&"
export * from "./client-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports